class ProductCardSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = this.querySelector('.swiper');
      if (this.swiper) {
        return;
      }
    }

    connectedCallback() {
      this.initSwiper(this.swiper);
    }

    disconnectedCallback() {
      if (this.swiperInstance?.destroy) {
        this.swiperInstance.destroy(true, true);
      }
    }

    initSwiper(swiper) {
      if (swiper) {
        this.swiperInstance = new window.swiper(swiper, {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          nested: true,
          preloadImages: false,
          watchSlidesProgress: true,

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: true,
          },
          on: {
            afterInit: () => {
              swiper.classList.add('loaded');
            },
          },
        });
      }
    }
  }

  customElements.define('product-card-swiper', ProductCardSwiper);